module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-stone-path-remnants.3b0586bf.png";